export default "__VITE_ASSET__z5Wqs8VY__"